import useObjectState from "@clave/use-object-state";
import React, { useEffect, useRef, useState } from "react";
import { validateUpdateSingle } from "../../validation/updateUserValidation";
import { ContentType } from "./EditUserInfo";
import PopupContent from "./popup-content/PopupContent";
import styles from "./popup.module.scss";
export default function Popup({ strings, contentType, userInfo, countries, save, open, close, children, customerServiceUrl, }) {
    const initObject = {
        confirmationPassword: "",
        newPassword: "",
        repeatedNewPassword: "",
        newMobilePhoneNumber: userInfo.mobilePhoneNumber,
    };
    const initError = {
        confirmationPasswordErr: "",
        newPasswordErr: "",
        repeatedNewPasswordErr: "",
        newEmailErr: "",
        newMobilePhoneNumberErr: "",
        line1Err: "",
        postalCodeErr: "",
        cityErr: "",
        countryIdErr: "",
    };
    const popupRef = useRef();
    function handleClickOutside(event) {
        if (popupRef && !popupRef.current.contains(event.target)) {
            closeAndClear();
        }
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const [objectToSave, setObjectToSave] = useObjectState(initObject);
    const [address, setAddress] = useState(userInfo.deliveryAddress);
    const [error, setError] = useState(initError);
    const [isValid, setIsValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const handleInputChange = (event, isAddress = false) => {
        const target = event.target;
        const value = target.type === "checkbox"
            ? target.checked
            : target.value;
        const name = target.name;
        if (isAddress) {
            setAddress((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
        else {
            setObjectToSave.set(name, value);
        }
    };
    const resetStates = () => {
        setError({ ...initError });
        setIsValid(true);
        setIsLoading(false);
    };
    useEffect(() => {
        setObjectToSave({ ...initObject });
    }, [open]);
    const validateInput = (inputName, isAddress = false) => {
        let err = validateUpdateSingle(isAddress ? address : objectToSave, inputName);
        const errMessage = err === undefined
            ? null
            : err[0].options !== undefined
                ? err[0].options.message
                : err[0];
        let obj = { ...error };
        obj[`${inputName}Err`] = errMessage !== null && errMessage !== void 0 ? errMessage : "";
        setIsValid(err ? false : true);
        setError({ ...obj });
    };
    const saveData = async () => {
        let obj = {};
        let url = "/update/";
        if (!isValid) {
            return;
        }
        setIsLoading(true);
        switch (contentType) {
            case ContentType.Password:
                obj = {
                    email: userInfo.email,
                    confirmationPassword: objectToSave.confirmationPassword,
                    newPassword: objectToSave.newPassword,
                    repeatedNewPassword: objectToSave.repeatedNewPassword,
                };
                url += "password";
                break;
            case ContentType.Address:
                obj = { ...address };
                url += "address";
                break;
            case ContentType.Mobile:
                obj = {
                    email: userInfo.email,
                    confirmationPassword: objectToSave.confirmationPassword,
                    mobilePhoneNumber: userInfo.mobilePhoneNumber,
                    newMobilePhoneNumber: objectToSave.newMobilePhoneNumber,
                };
                url += "mobile";
                break;
            case ContentType.CustomerService:
                location.href = customerServiceUrl;
                resetStates();
                return;
        }
        await save(obj, url);
        resetStates();
    };
    const closeAndClear = () => {
        resetStates();
        close();
    };
    return (React.createElement("form", { onSubmit: (e) => {
            e.preventDefault();
            saveData();
        }, ref: popupRef, className: `${styles.popup} ${open ? styles.open : ""} ` },
        React.createElement("button", { type: "button", className: styles.closeButton, onClick: closeAndClear },
            React.createElement(CrossSvg, null)),
        React.createElement("div", { className: styles.popupContent },
            React.createElement(PopupContent, { validateInput: validateInput, contentType: contentType, strings: strings, objectToSave: objectToSave, handleInputChange: handleInputChange, error: error, countries: countries, address: address, setAddress: setAddress })),
        children,
        React.createElement("div", { className: "btn-wrapper flex-container-row flex-end" }, contentType != ContentType.Confirmation ? (React.createElement("button", { disabled: !isValid || isLoading, className: `${styles.submit} button btn primary` }, isLoading ? (React.createElement("span", { className: "disabled circle-loader {display: none;}" })) : contentType == ContentType.CustomerService ? (strings.goToCustomerService) : (strings.edit))) : null)));
}
const CrossSvg = () => (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M15.4414 2.56641L13.6836 0.808594L8 6.47266L2.31641 0.808594L0.558594 2.56641L6.22266 8.25L0.558594 13.9336L2.31641 15.6914L8 10.0273L13.6836 15.6914L15.4414 13.9336L9.77734 8.25L15.4414 2.56641Z", fill: "black" })));
